import { render, staticRenderFns } from "./BosAdminNavigation.vue?vue&type=template&id=623861d0&scoped=true"
import script from "./BosAdminNavigation.vue?vue&type=script&lang=js"
export * from "./BosAdminNavigation.vue?vue&type=script&lang=js"
import style0 from "./BosAdminNavigation.vue?vue&type=style&index=0&id=623861d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623861d0",
  null
  
)

export default component.exports